const fetchLinks = {
	temperature: `https://global-warming.org/api/temperature-api`,
	co2: `https://global-warming.org/api/co2-api`,
	methane: `https://global-warming.org/api/methane-api`,
	no2: `https://global-warming.org/api/nitrous-oxide-api`,
	glaciers: `https://global-warming.org/api/arctic-api`,
};

export default fetchLinks;
